 import { useMutation } from "@tanstack/react-query";
import { message } from "antd";  
import { AxiosError } from "axios";
import apiClient from ".";
import { extractErrorMessage } from "./ErrorHandler";

interface UsePutDataProps<T, V> {
  url: string;
  options?: {
    onSuccess?: (data: T) => void;
    onError?: (error: AxiosError) => void;
  };
}

export const usePutData = <T, V>({ url, options }: UsePutDataProps<T, V>) => {
  return useMutation<T, AxiosError, V>({
    mutationFn: async (data: V) => {
      const response = await apiClient.put<T>(url, data);
      return response.data;
    },
    onError: (error) => {
      const errorMessage = extractErrorMessage(error);
      message.error(errorMessage); 
      if (options?.onError) options.onError(error);
    },
    ...options,  
  });
};
